/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSendIncrementModel,
  ISendIncrementRequest,
  IMappers,
  ISendIncrementResponse,
  ISendIncrementResponseError,
  TSendIncrementResponse,
} from './types';

const defaultConfig: TSendIncrementModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'browser-telemetry',
  pathApi: '/v1/send-increment/',
  hostType: 'api',
} as TSendIncrementModel;

function createSendIncrementModel(parameters: ISendIncrementRequest): TSendIncrementModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISendIncrementOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISendIncrementRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSendIncrement<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISendIncrementOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TSendIncrementResponse> {
  const { response, statusCode } = await httpApi.fetch(createSendIncrementModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISendIncrementResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISendIncrementResponseError);
    }
  }

  return { response, statusCode } as TSendIncrementResponse;
}

export { defaultConfig, createSendIncrementModel, fetchSendIncrement };
